import { useEffect } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { useLocation } from 'wouter';
import { useToast } from '@/hooks/use-toast';

export default function LogoutPage() {
  const { logout } = useAuth();
  const [, setLocation] = useLocation();
  const { toast } = useToast();

  useEffect(() => {
    const performLogout = async () => {
      try {
        await logout();
        toast({
          title: 'Logged out successfully',
          description: 'You have been logged out of your account.',
        });
        // Redirect to landing page
        window.location.href = '/';
      } catch (error) {
        console.error('Logout error:', error);
        // Even if logout fails, redirect to landing page
        window.location.href = '/';
      }
    };

    performLogout();
  }, [logout, setLocation, toast]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-hydro-100 font-kumbh">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-4 border-lilac-300 border-t-purple-500 mx-auto mb-4"></div>
        <h2 className="text-xl font-semibold text-deep-800 mb-2">Logging out...</h2>
        <p className="text-deep-500">Please wait while we log you out securely.</p>
      </div>
    </div>
  );
}
